import { z } from "zod";
/**
 * Portal workspace schemas.
 *
 * A workspace is the tenant-local commercial wrapper for the client portal.
 * L30 Premium and Client Hub use the same portal engine but differ in package
 * expression, naming, and light white-label settings.
 */
export const PortalWorkspacePackageKindSchema = z.enum(["l30_premium", "client_hub"]);
const PortalAccentColorSchema = z
    .preprocess((value) => (value === "" ? null : value), z
    .string()
    .regex(/^#[0-9a-fA-F]{6}$/)
    .nullable())
    .default(null);
const OptionalStringToNullSchema = z
    .preprocess((value) => (typeof value === "string" && value.trim() === "" ? null : value), z.string().trim().min(1).max(1000).nullable())
    .default(null);
export const PortalWorkspaceSchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1).max(200),
    packageKind: PortalWorkspacePackageKindSchema.default("l30_premium"),
    portalEnabled: z.boolean().default(true),
    accentColor: PortalAccentColorSchema,
    logoBlobKey: OptionalStringToNullSchema,
    companyId: z.string().uuid().nullable(),
    status: z.string().min(1).max(20),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const PortalWorkspaceListResponseSchema = z.object({
    workspaces: z.array(PortalWorkspaceSchema),
});
export const PortalWorkspaceProvisionSchema = z.object({
    name: z.string().trim().min(1).max(200).optional(),
    packageKind: PortalWorkspacePackageKindSchema.default("l30_premium"),
    portalEnabled: z.boolean().default(true),
    accentColor: PortalAccentColorSchema.optional(),
    logoBlobKey: OptionalStringToNullSchema.optional(),
});
export const PortalWorkspaceUpdateSchema = z
    .object({
    name: z.string().trim().min(1).max(200),
    packageKind: PortalWorkspacePackageKindSchema,
    portalEnabled: z.boolean(),
    accentColor: PortalAccentColorSchema,
    logoBlobKey: OptionalStringToNullSchema,
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: "At least one workspace field must be supplied",
});
export const PortalWorkspaceResponseSchema = z.object({
    workspace: PortalWorkspaceSchema,
});
//# sourceMappingURL=portal-workspace.js.map